/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Read_Along_Ai_SectionsInputs */

const en_read_along_ai_sections = /** @type {(inputs: Read_Along_Ai_SectionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reading sections: ${i?.completed} of ${i?.total} complete`)
};

const es_read_along_ai_sections = /** @type {(inputs: Read_Along_Ai_SectionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leyendo secciones: ${i?.completed} de ${i?.total} completadas`)
};

/**
* | output |
* | --- |
* | "Reading sections: {completed} of {total} complete" |
*
* @param {Read_Along_Ai_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_sections = /** @type {((inputs: Read_Along_Ai_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_sections(inputs)
	return en_read_along_ai_sections(inputs)
});